import { http } from '@/config';
import {
  CONNECTORS_MANUAL_FIELDS_START_CHARGE_URL,
  CONNECTORS_START_CHARGE_URL,
  CONNECTORS_STOP_CHARGE_URL,
} from '@/modules/charge-center/grid-connections/api/connectors/endpoints';
import {
  remoteTransactionResponse,
  type RemoteTransactionResponse,
} from '@/modules/charge-center/grid-connections/api/connectors/types';
import { isAxiosError } from 'axios';

export const startCharge = async (connectorId: number) => {
  const response = await http.get<RemoteTransactionResponse>(
    CONNECTORS_START_CHARGE_URL(connectorId)
  );
  if (isAxiosError(response)) return response;
  remoteTransactionResponse.parse(response.data);
  return response;
};

export const startManualFieldsCharge = async (
  connectorId: number,
  vehicleNumberPlate: string,
  odometerValue: string
) => {
  const response = await http.get<RemoteTransactionResponse>(
    CONNECTORS_MANUAL_FIELDS_START_CHARGE_URL(connectorId, vehicleNumberPlate, odometerValue)
  );
  if (isAxiosError(response)) return response;
  remoteTransactionResponse.parse(response.data);
  return response;
};

export const stopCharge = async (connectorId: number) => {
  const response = await http.get<RemoteTransactionResponse>(
    CONNECTORS_STOP_CHARGE_URL(connectorId)
  );
  if (isAxiosError(response)) return response;
  remoteTransactionResponse.parse(response.data);
  return response;
};
